import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';

export default function PotatoHuntStepThankYou({participationData, promotionSettings}) {
	const {t, i18n} = useTranslation();


	const winingInfoTextMarkets = ["BE", "NL"];
	const isValidMarket = winingInfoTextMarkets.includes(promotionSettings.promotion_page.market); // checks if BE or NL
	const hasWonStatus = participationData.result.status === "won";

	const renderWiningInfoText = () => {
		if (isValidMarket && hasWonStatus) {
			return (
				<div className="winning-info-text-wrap">
					<p className="text step-content-large">{t("Congratulations, you will receive a confirmation email within 3 working days.")} </p>
				</div>
			);
		}
		return null;
	}


	return (
		<div className="step-potato-hunt-text">
			<p className="step-title-large">{t("Thank \nyou")} </p>
			<p className="step-content-large">{t("For taking part in our daily competition! Come back tomorrow for another opportunity to win €1,000.")}</p>
			<a href={window.home}
			   className="btn btn-primary cta primary-cta ">{t('Return to Homepage')}</a>
			{renderWiningInfoText()}
		</div>
	)
}

